/*
 * returns an iso-3166 alpha 2 digit country code or a UN M.49 3 digit code
 * that matches the device's region
 */
export function getDeviceRegion(): string | undefined {
  const dtf = new Intl.DateTimeFormat()

  const locale = new Intl.Locale(dtf.resolvedOptions().locale)
  /*
   * https://developer.mozilla.org/en-US/docs/Glossary/BCP_47_language_tag#region_subtag_optional
   *
   * the region subtag is either two upper-case letters matching a country code
   * or three numbers matching a non-country area
   */
  return locale.region
}
